import React, { Component } from 'react';
import { LeaderboardContext } from '../context';

import styled from '@emotion/styled';

// eslint-disable-next-line import/default
import apiWorker from 'workerize-loader!../api';
import ScoredCarousel from '../components/scored_carousel';

class ConnectedCarouselScored extends Component {
  constructor(props) {
    super(props);

    this.state = {
      entries: {
        fetching: false,
        fetched: false,
        data: [],
      },

      judgedQuestions: {
        data: [],
      },

      calculatedQuestionsWithWinners: {
        data: [],
      },

      leaderboard: {
        fetching: false,
        fetched: props.leaderboard ? true : false,
        errors: [],
        data: { ...props.leaderboard.data, promoPages: [] },
      },

      questions: {
        fetching: false,
        fetched: false,
        data: [],
      },
    };

    this.worker = new apiWorker();

    this.worker.setBaseUrl(`//api.${props.domain}/events/${props.eventId}`);
    this.worker.setHeaders({
      Accept: 'application/vnd.api+json',
      Authorization: `Bearer ${props.accessToken}`,
    });
  }

  async _leaderboardFetch() {
    return await this.worker.fetchLeaderboard();
  }

  async _entriesFetch() {
    return await this.worker.fetchEntries();
  }

  async _questionsFetch() {
    return await this.worker.fetchQuestions();
  }

  async _fetchNewData() {
    const allFetches = Promise.all([
      this._leaderboardFetch(),
      this._entriesFetch(),
      this._questionsFetch(),
    ]);

    const [leaderboardRes, userEntriesRes, questionsRes] = await allFetches;

    const calculatedQuestionsWithWinners =
      await this.worker.calculateQuestionsWithWinners(
        questionsRes.judgedQuestions,
        userEntriesRes
      );

    this.setState(state => ({
      connectedOnce: true,
      leaderboard: {
        ...state.leaderboard,
        fetching: false,
        fetched: true,
        data: {
          ...state.leaderboard.data,
          promoPages: leaderboardRes,
        },
      },
      entries: {
        ...state.entries,
        fetching: false,
        fetched: true,
        data: userEntriesRes,
      },
      questions: {
        ...state.questions,
        fetching: false,
        fetched: true,
        data: questionsRes.questions,
      },
      judgedQuestions: {
        ...state.judgedQuestions,
        data: questionsRes.judgedQuestions,
      },
      calculatedQuestionsWithWinners: {
        data: calculatedQuestionsWithWinners,
      },
    }));
  }

  componentDidMount() {
    this._fetchNewData();
  }

  render() {
    const {
      leaderboard,
      calculatedQuestionsWithWinners,
      entries,
      judgedQuestions,
      questions,
    } = this.state;

    const { Loading } = ConnectedCarouselScored;

    if (leaderboard.fetched && entries.fetched && questions.fetched) {
      return (
        <LeaderboardContext.Provider value={this.state.leaderboard.data}>
          <ScoredCarousel
            animationEndedCallback={() => this._fetchNewData()}
            promoPages={leaderboard.data.promoPages}
            userEntries={entries.data}
            questions={questions.data}
            calculatedQuestions={judgedQuestions.data}
            calculatedQuestionsWithWinners={calculatedQuestionsWithWinners.data}
            promoPageTimer={leaderboard.data.attributes.promo_page_timer}
            entriesPageTimer={leaderboard.data.attributes.entries_page_timer}
            resultsPageTimer={leaderboard.data.attributes.results_page_timer}
            winnerPageTimer={leaderboard.data.attributes.winner_page_timer}
          />
        </LeaderboardContext.Provider>
      );
    } else {
      return <Loading>Loading</Loading>;
    }
  }
}

ConnectedCarouselScored.Loading = styled.h1`
  color: ${props => props.theme.backgroundTextColor};
`;

export default ConnectedCarouselScored;
